import { render } from "./About.vue?vue&type=template&id=66eb336d&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=66eb336d&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66eb336d"]])

export default __exports__